 
import Button from "@material-ui/core/Button";
 
const LinkButton = ({additionClass,loading,text,handleClick}) => {
    return (
      
        <Button
            className={"link-btn "+additionClass}
            onClick={handleClick}
            type="button"
            disabled={loading}
            >
           { text }
        </Button>
       
    );
  }
  
  export default LinkButton;
  